import React, { forwardRef } from "react";

const Card = forwardRef(({ className, cardBgColor, children,style }, ref) => {
    const bgClass = cardBgColor ? cardBgColor === "light" ? ' bg-' + cardBgColor : ' text-white bg-' + cardBgColor : '';
    const classes = `card${bgClass}${className ? ' ' + className : ''}`;
    return (
        <div ref={ref} className={classes} style={style}>
            <div className="card-body">
                {children}
            </div>
        </div>
    );
});

export default Card;